import { Controller } from "stimulus";
import { MarkerClusterer } from "@googlemaps/markerclusterer";

class ClusterController extends Controller {
  static targets = ["map"]

  connect() {
    this.initMap()
    this.infoWindow = new google.maps.InfoWindow({
      content: "",
      disableAutoPan: true,
    });
    this.clusterer = new MarkerClusterer({markers: [], map: this.map});
    this.loadMarkers()
  }

  initMap() {
    this.map = new google.maps.Map(this.mapTarget, {
      zoom: 11,
      center: {
        lat: 37.6,
        lng: 127.0
      },
    });
  }

  loadMarkers() {
    fetch(this.fetchUrl)
      .then(response => response.json())
      .then(({trading_locations}) => {
        console.log(trading_locations)
        this.lastId = trading_locations[trading_locations.length - 1].id
        return trading_locations
      }).then(trading_locations => trading_locations.map(({ latitude, longitude, name }) => this.buildMarker(latitude, longitude, name)))
      .then(markers => this.clusterer.addMarkers(markers))
  }

  clusterMarkers(markers) {
    this.clusterer.addMarkers(markers)
  }

  buildMarker(lat, lng, title) {
    console.log(lat, lng, title)
    const marker = new google.maps.Marker({
      position: {
        lat: lat,
        lng: lng,
      },
      title: title,
      // map: this.map
    });

    console.log(this.map)
    marker.addListener("click", () => {
      this.infoWindow.setContent(title);
      this.infoWindow.open(this.map, marker);
    });
    return marker;
  }

  get fetchUrl() {
    if (this.lastId === undefined) {
      return "/admin/trading_locations/map.json"
    } else {
      return `/admin/trading_locations/map.json?last_id=${this.lastId}`;
    }
  }
}

export default ClusterController;